<span class="timerText">{{ remainingTime }}</span>
